import { useState } from 'react';
import { useLang } from 'hooks/lang';

import { invoiceStatusConfig, actions } from 'entities';

import { Button, Column, Row } from 'components/Blocks';
import { CircleXIcon, FileCheckIcon } from 'components/Icons';
import { UploadFileDropzone } from 'components/Uploads';

import { useFormControl } from 'hooks';
import { useUser } from 'hooks/user';

import { PaymentDate } from './Date';

import { InvoiceTabProps } from '../../types';
import { UploadedFile } from 'types';
import { getFirst } from 'utils/array';

export function ConfirmPayment({ invoice, overwrite, changeTab, closeModal }: InvoiceTabProps) {
  const { t } = useLang();
  const user = useUser();

  const [invoiceFiles, setInvoiceFiles] = useState<UploadedFile[]>([]);

  const { state, dispatch } = useFormControl({
    date: null as string | null,
  });

  const uploadBlock = [!Object.values(state).every(Boolean), !invoiceFiles.length].some(Boolean);

  const uploadInvoice = actions.invoice.uploadOutsourceInvoicePayment.use({
    block: uploadBlock,

    params: {
      id: invoice.id,
      date: state.date as string,
      file: getFirst(invoiceFiles),
    },

    onSuccess: () => {
      overwrite((old) => ({
        ...old,
        ...state,
        files: [...old.files, { ...getFirst(invoiceFiles), uploadedBy: user }],
        status: invoiceStatusConfig.paid.code,
      }));

      changeTab('data');
    },
  });

  return (
    <>
      <Column gap="8">
        <h6 className="text-center font-semibold">{t('register-payment')}</h6>

        <Column gap="6">
          <PaymentDate state={state} dispatch={dispatch} />

          <UploadFileDropzone
            files={invoiceFiles}
            setFiles={setInvoiceFiles}
            uploadPrefix={`invoices/${invoice.id}` as 'invoiceId'}
            multiple={false}
            showInputOnDisabled={false}
            acceptedFormats={[
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/pdf',
              'image/*',
            ]}
          />
        </Column>
      </Column>

      <Row justifyContent="space-between">
        <Button variant="outlined" onClick={closeModal}>
          <CircleXIcon />
          {t('cancel')}
        </Button>

        <Button disabled={uploadBlock} {...uploadInvoice.buttonProps}>
          {t('confirm')}
          <FileCheckIcon />
        </Button>
      </Row>
    </>
  );
}
